{
  "version": 1,
  "asset_id": "42480ebd-59e8-4e78-aec1-aa6cfda1032c",
  "project_id": "8e4d2e04-d0e9-4cb0-997e-36f9edfa9f56",
  "url": "/__l5e/assets-v1/42480ebd-59e8-4e78-aec1-aa6cfda1032c/Cable_replacement.webp",
  "r2_key": "a/v1/8e4d2e04-d0e9-4cb0-997e-36f9edfa9f56/42480ebd-59e8-4e78-aec1-aa6cfda1032c/Cable_replacement.webp",
  "original_filename": "Cable_replacement.webp",
  "size": 110954,
  "content_type": "image/webp",
  "created_at": "2026-08-10T03:59:45Z"
}
